<ul id="main-menu" class="navbar-nav">
    <ng-container *ngIf="!isGrantsMode(); else grantsMainMenu">
      <li class="nav-item" [class.open]="isOpen('dashboard')">
        <a class="nav-link" routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          title="Dashboard">
          <i class="mdi mdi-view-dashboard fa-fw" data-icon="v"></i>
          <span class="d-md-inline">Dashboard <span class="fa fa-angle-down" (click)="onCaret('dashboard', $event)"></span></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a class="dropdown-item" routerLink="/dashboard" title="Home" routerLinkActive="active">
              <img src="/assets/img/nav_icons/chart-home.png">
              <span class="d-md-inline">Home</span>
            </a>
          </li>
          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/tools/rules/overview')" title="Health Check"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/chart-home.png">
              <span class="d-md-inline">Health Check</span>
            </a>
          </li>
          <li *ngIf="getCurrentCompanyId()">
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/charts/brand')" title="Chart-Brand"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/bureau.png">
              <span class="d-md-inline">Chart-Brand</span>
            </a>
          </li>
          <li *ngIf="getCurrentCompanyId()">
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/charts/company')" title="Chart-Company"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/chart-company.png">
              <span class="d-md-inline">Chart-Company</span>
            </a>
          </li>
          <li *ngIf="getCurrentCompanyId()">
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/charts/global')" title="Chart-Global"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/chart-global.png">
              <span class="d-md-inline">Chart-Global</span>
            </a>
          </li>
          <li *ngIf="getCurrentCompanyId()">
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/maps/event')" title="Chart-Global"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/chart-event.png">
              <span class="d-md-inline">Map Events</span>
            </a>
          </li>
          <li *ngIf="getCurrentCompanyId()">
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/maps/speaker')" title="Map Events"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/chart-speakers.png">
              <span class="d-md-inline">Map Speakers</span>
            </a>
          </li>
        </ul>
      </li>
      <!-- EVENTS INFO SECTION STARTS HERE -->
      <li class="nav-item" *ngIf="getCurrentCompanyId()" [class.open]="isOpen('events')">
        <a class="nav-link" [routerLink]="getCompanyBureauUrl('/events/bureau')" title="Events" id="event-icon"
          routerLinkActive="active">
          <i class="mdi mdi-calendar fa-fw" data-icon="v"></i>
          <span class="d-md-inline">Events <span class="fa fa-angle-down" (click)="onCaret('events', $event)"></span></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/events/bureau')" title="Bureau"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/bureau.png">
              <span class="d-md-inline">Bureau</span>
            </a>
          </li>
          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/requests')" title="Pending Requests"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/pending-request.png">
              <span class="d-md-inline">Pending Requests</span>
            </a>
          </li>
          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/overview')" title="Overview"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/preview.png">
              <span class="d-md-inline">Overview</span>
            </a>
          </li>
          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/events/calendar')" title="Calendar"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/calendar.png">
              <span class="d-md-inline">Calendar</span>
            </a>
          </li>
          <li *ngIf="authenticationService.is_staff() || authenticationService.is_agency_staff()">
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/events/public-calendar')"
              title="Agency Calendar" routerLinkActive="active">
              <img src="/assets/img/nav_icons/public-calendar.png">
              <span class="d-md-inline">Agency Calendar</span>
            </a>
          </li>
          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/events/monitor-live')" title="Monitor Live"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/monitor-live.png">
              <span class="d-md-inline">Monitor Live</span>
            </a>
          </li>
          <li *ngIf="authenticationService.is_staff()">
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/forums')" title="Forums"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/forum.png">
              <span class="d-md-inline">Forums</span>
            </a>
          </li>
          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/non-bureau/events')" title="Non-Bureau"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/non-bureau.png">
              <span class="d-md-inline">Non-Bureau</span>
            </a>
          </li>
        </ul>

      </li>
      <!-- EVENTS INFO SECTION ENDS HERE -->

      <li class="nav-item" *ngIf="getCurrentCompanyId()" [class.open]="isOpen('resources')">
        <a class="nav-link" [routerLink]="getCompanyBureauUrl('/reports')" routerLinkActive="active"
          title="Resources">
          <i class="mdi mdi-clipboard-text fa-fw" data-icon="v"></i>
          <span class="d-md-inline">Resources <span class="fa fa-angle-down" (click)="onCaret('resources', $event)"></span>
          </span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/resource/presentations')" title="Presentations"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/presentation.png">
              <span class="d-md-inline">Presentations</span>
            </a>
          </li>

          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/reports')" title="Reports"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/reports.png">
              <span class="d-md-inline">Reports</span>
            </a>
          </li>

          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/reports-custom')" title="Reports - Custom"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/custom-reports.png">
              <span class="d-md-inline">Reports – Custom</span>
            </a>
          </li>

          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/resource/library')"
              title="Resource Library" routerLinkActive="active">
              <img src="/assets/img/nav_icons/resource-library.png">
              <span class="d-md-inline">Resource Library</span>
            </a>
          </li>

          <li>
            <a class="dropdown-item" [routerLink]="'/tools/topic'" [queryParams]="{ company_id: getCurrentCompanyId() }"
              title="Topics" routerLinkActive="active">
              <img src="/assets/img/nav_icons/presentation.png">
              <span class="d-md-inline">Topics</span>
            </a>
          </li>

          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/tools/training_module')"
              title="Training Modules" routerLinkActive="active">
              <img src="/assets/img/nav_icons/training-modules.png">
              <span class="d-md-inline">Training Modules</span>
            </a>
          </li>

          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/venues')" title="Venue Directory"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/venue-directory.png">
              <span class="d-md-inline">Venue Directory</span>
            </a>
          </li>

          <li *ngIf="authenticationService.is_super()">
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/profiles/venues')"
              title="Venue Nominations" routerLinkActive="active">
              <img src="/assets/img/nav_icons/venue-nominations.png">
              <span class="d-md-inline">Venue Nominations</span>
            </a>
          </li>
        </ul>
      </li>

      <li class="nav-item" *ngIf="getCurrentCompanyId()" [class.open]="isOpen('finance')">
        <a class="nav-link" title="Payments" [routerLink]="getCompanyBureauUrl('/finance/budgets')"
          [queryParams]="{fiscal_year: fiscalYearId}" routerLinkActive="active">
          <i class="mdi mdi-cash-multiple fa-fw" data-icon="v"></i>
          <span class="d-md-inline">Finance <span class="fa fa-angle-down" (click)="onCaret('finance', $event)"></span></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a class="dropdown-item" title="Balance" [routerLink]="getCompanyBureauUrl('/finance/balance')"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/balance.png">
              <span class="d-md-inline">Balance </span>
            </a>
          </li>
          <li>
            <a class="dropdown-item" title="Budgets" [routerLink]="getCompanyBureauUrl('/finance/budgets')"
              [queryParams]="{fiscal_year: fiscalYearId}" routerLinkActive="active">
              <img src="/assets/img/nav_icons/budget.png">
              <span class="d-md-inline">Budgets</span>
            </a>
          </li>
          <li>
            <a class="dropdown-item" title="Payments" [routerLink]="getCompanyBureauUrl('/finance/payments')"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/payment.png">
              <span class="d-md-inline">Payments </span>
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item" [class.open]="isOpen('people')">
        <a class="nav-link" title="People" [routerLink]="getCompanyBureauUrl('/profiles/speakers')" routerLinkActive="active">
          <i class="mdi mdi-account-settings fa-fw"></i>
          <span class="d-md-inline">People <span class="fa fa-angle-down" (click)="onCaret('people', $event)"></span></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/profiles/speakers')" title="Speakers"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/speakers.png">
              <span class="d-md-inline">Speakers</span>
            </a>
          </li>
          <li *ngIf="getCurrentCompanyId()">
            <a class="dropdown-item" title="Attendees" [routerLink]="getCompanyBureauUrl('/profiles/attendees')"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/attendees.png">
              <span class="d-md-inline">Attendees</span>
            </a>
          </li>
          <li *ngIf="getCurrentCompanyId()">
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/profiles/call_plans')" title="Call Plans"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/call-plans.png">
              <span class="d-md-inline">Call Plans</span>
            </a>
          </li>
          <li *ngIf="!authenticationService.is_agency_staff() && getCurrentCompanyId()">
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/profiles/hcps')" title="HCP List"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/hcp-audience.png">
              <span class="d-md-inline">HCP Audience</span>
            </a>
          </li>
          <li>
            <a class="dropdown-item" title="KOL Contracting" [routerLink]="getCompanyBureauUrl('/kol-contracting')"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/kol-contracting.png">
              <span class="d-md-inline">KOL Contracting</span>
            </a>
          </li>
          <!-- <li>
            <a class="dropdown-item"
              title="KOL Management"
              [routerLink]="getCompanyBureauUrl('/kol-management')"
              routerLinkActive="active"
            >
              <i class="mdi mdi-chart-arc fa-fw"></i>
              <span class="d-md-inline">KOL Management </span>
            </a>
          </li> -->
          <!-- <li>
            <a class="dropdown-item" title="KOL Nominations" [routerLink]="getCompanyBureauUrl('/kol-nominations')"
              routerLinkActive="active">
              <i class="mdi mdi-chart-arc fa-fw"></i>
              <span class="d-md-inline">KOL Nominations </span>
            </a>
          </li> -->
          <li *ngIf="!authenticationService.is_agency_staff() && getCurrentCompanyId() && getCurrentAgencyId()">
            <a class="dropdown-item" [routerLink]="'/tools/agency/' + getCurrentAgencyId() +'/staff'" title="Staff"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/staff.png">
              <span class="d-md-inline">Staff</span>
            </a>
          </li>
          <li *ngIf="authenticationService.is_agency_staff()">
            <a class="dropdown-item" [routerLink]="'/tools/agency/' + authenticationService.staff_agency_id() +'/staff'"
              title="Staff" routerLinkActive="active">
              <img src="/assets/img/nav_icons/staff.png">
              <span class="d-md-inline">Staff</span>
            </a>
          </li>
          <li *ngIf="authenticationService.is_staff()">
            <a class="dropdown-item" routerLink="/profiles" title="Universe" routerLinkActive="active">
              <img src="/assets/img/nav_icons/universe.png">
              <span class="d-md-inline">Universe</span>
            </a>
          </li>
          <li *ngIf="authenticationService.is_staff()">
            <a class="dropdown-item" routerLink="/profiles/unsubscribed" title="Unsubscribed"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/universe.png">
              <span class="d-md-inline">Unsubscribed</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="authenticationService.is_staff() || authenticationService.is_agency_staff()">
        <a class="nav-link" title="Tools" routerLink="/tools" title="Manage Company & Branding"
          routerLinkActive="active">
          <i class="mdi mdi-settings fa-fw" data-icon="v"></i>
          <span class="d-md-inline">Tools
            <!-- <span class="fa fa-angle-down"></span> -->
          </span>
        </a>
      </li>
    </ng-container>

    <!-- Grants & Sponsorships scope: alternate menu shown when the grants pseudo-bureau is selected -->
    <ng-template #grantsMainMenu>
      <li class="nav-item" *ngIf="getCurrentCompanyId()" [class.open]="isOpen('dashboard')">
        <a class="nav-link" [routerLink]="getCompanyBureauUrl('/grants')" routerLinkActive="active"
          title="Dashboard">
          <i class="mdi mdi-view-dashboard fa-fw" data-icon="v"></i>
          <span class="d-md-inline">Dashboard <span class="fa fa-angle-down" (click)="onCaret('dashboard', $event)"></span></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/grants')" title="Grants Home"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/chart-home.png">
              <span class="d-md-inline">Grants Home</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="getCurrentCompanyId()" [class.open]="isOpen('grants')">
        <a class="nav-link" [routerLink]="getCompanyBureauUrl('/grants/draft')" title="Grants" routerLinkActive="active">
          <i class="mdi mdi-wechat fa-fw" data-icon="v"></i>
          <span class="d-md-inline">Grants <span class="fa fa-angle-down" (click)="onCaret('grants', $event)"></span></span>
        </a>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/grants/draft')" routerLinkActive="active">Draft</a></li>
          <li><a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/grants/pending')" routerLinkActive="active">Pending</a></li>
          <li><a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/grants/conditional')" routerLinkActive="active">Conditional</a></li>
          <li><a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/grants/conditional-approval')" routerLinkActive="active">Conditional Approval</a></li>
          <li><a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/grants/approved')" routerLinkActive="active">Approved</a></li>
          <li><a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/grants/archived')" routerLinkActive="active">Archived</a></li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="getCurrentCompanyId()" [class.open]="isOpen('resources')">
        <a class="nav-link" [routerLink]="getCompanyBureauUrl('/grants/reports')" routerLinkActive="active"
          title="Resources">
          <i class="mdi mdi-clipboard-text fa-fw" data-icon="v"></i>
          <span class="d-md-inline">Resources <span class="fa fa-angle-down" (click)="onCaret('resources', $event)"></span></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/grants/reports')" title="Reports"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/reports.png">
              <span class="d-md-inline">Reports</span>
            </a>
          </li>
          <li>
            <a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/grants/reports-custom')" title="Reports - Custom"
              routerLinkActive="active">
              <img src="/assets/img/nav_icons/custom-reports.png">
              <span class="d-md-inline">Reports – Custom</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="getCurrentCompanyId()">
        <a class="nav-link" href="javascript:void(0)" title="Finance">
          <i class="mdi mdi-cash-multiple fa-fw" data-icon="v"></i>
          <span class="d-md-inline">Finance</span>
        </a>
      </li>
      <li class="nav-item" *ngIf="getCurrentCompanyId()" [class.open]="isOpen('people')">
        <a class="nav-link" [routerLink]="getCompanyBureauUrl('/grants/people/applicants')" routerLinkActive="active"
          title="People">
          <i class="mdi mdi-account-settings fa-fw"></i>
          <span class="d-md-inline">People <span class="fa fa-angle-down" (click)="onCaret('people', $event)"></span></span>
        </a>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/grants/people/applicants')" routerLinkActive="active">Applicants</a></li>
          <li><a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/grants/people/principals')" routerLinkActive="active">Principals</a></li>
          <li><a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/grants/people/recipients')" routerLinkActive="active">Recipients</a></li>
          <li><a class="dropdown-item" [routerLink]="getCompanyBureauUrl('/grants/people/staff')" routerLinkActive="active">Staff</a></li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="authenticationService.is_staff() || authenticationService.is_agency_staff()">
        <a class="nav-link" title="Tools" routerLink="/tools/grants" routerLinkActive="active">
          <i class="mdi mdi-settings fa-fw" data-icon="v"></i>
          <span class="d-md-inline">Tools</span>
        </a>
      </li>
    </ng-template>
    </ul>
